import ranking from '../api/ranking.api'
import store from './index.js'
import Vue from 'vue'

// root state object.
// each Vuex instance is just a single state tree.
const state = {
  ranking_lines: [],
  rankingForWeek: {}
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  refreshLines (state, rankingLines) {
    state.ranking_lines = rankingLines
  },
  addRankingForWeek (state, datas) {
    Vue.set(state.rankingForWeek, datas[1], datas[0])
  },
  removeRanking (state) {
    state.ranking_lines = null
    state.rankingForWeek = {}
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  /*
  getRanking (context) {
    ranking.api.getRanking()
      .then(response => {
        context.commit('refreshLines', response.data)
      },
      error => {
        console.log('impossible to load ranking from api: ')
        console.log(error)
      })
  },
  */
  getRankingForWeek (context, weekId) {
    ranking.api.getRankingForWeek(weekId)
      .then(response => {
        context.commit('addRankingForWeek', [response.data, weekId])
      },
      error => {
        console.log('impossible to load ranking from api: ')
        console.log(error)
      })
  },
  invalidateRanking (context) {
    context.commit('removeRanking')
  }
}

// getters are functions
const getters = {
  ranking: state => {
    return state.ranking_lines
  },
  filteredRanking: state => {
    if (store.getters.activatedLeague && state.ranking_lines) {
      let al = store.getters.activatedLeague
      let filtered = state.ranking_lines.filter(rl => { return rl.league_id === al })
      return filtered
    }
    return state.ranking_lines
  },
  rankingForWeek: (state, getters) => (weekId) => {
    return state.rankingForWeek[weekId]
  },
  rankingForGroupAndDay: (state, getters) => (rgId, weekId) => {
    // on prend la liste des lignes de classements pour le ranking_group
    let rankingForDay = getters.rankingForWeek(weekId)
    let filtered = []
    if (rankingForDay) {
      filtered = getters.rankingForWeek(weekId).filter(rl => { return rl.ranking_group_id === rgId })
    }
    return filtered
  },
  orderedRankingForGroupAndDay: (state, getters) => (rgId, weekId) => {
    let filtered = getters.rankingForGroupAndDay(rgId, weekId)
    return filtered.sort((r1, r2) => {
      if (r1.ranking_points > r2.ranking_points) {
        return -1
      }
      if (r1.ranking_points < r2.ranking_points) {
        return 1
      }
      for (let i = 0; i < r1.bonus_points.length; i++) {
        if (r1.bonus_points[i].value > r2.bonus_points[i].value) {
          return -1
        }
        if (r1.bonus_points[i].value < r2.bonus_points[i].value) {
          return 1
        }
      }
      return 0
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/ranking.js